import clsx from 'clsx'
import React from 'react'
import { ComponentsProps } from './Type'
import useStyles from './Style'

const QualificationLayout: React.FC<ComponentsProps> = ({
  BlockProgress,
  BlockHeader,
  BlockStepper,
  BlockMain,
  BlockGdpr,
  BlockConsent,
  BlockSidebar,
  primaryFullWidth,
  primaryCenter,
  hideContent,
}) => {
  const classes = useStyles()
  return (
    <>
      <main className={classes.main}>
        <div className={clsx(classes.primary, primaryCenter && classes.primaryCenter)}>
          {!hideContent ? (
            <>
              {BlockProgress && BlockProgress}
              {BlockHeader && BlockHeader}
              <div className={classes.primaryInner}>
                {BlockStepper && BlockStepper}
                <div
                  className={clsx(
                    classes.primaryForm,
                    primaryFullWidth && classes.primaryFormFullWidth,
                    !BlockStepper && classes.primaryFormFullWidth
                  )}
                >
                  {BlockMain && BlockMain}
                </div>
              </div>
            </>
          ) : (
            <div />
          )}
          {BlockConsent && <div className={classes.consent}>{BlockConsent}</div>}
          {BlockGdpr && BlockGdpr}
        </div>
        {BlockSidebar && <div className={classes.secondary}>{BlockSidebar}</div>}
      </main>
    </>
  )
}

export default QualificationLayout
